import { t } from 'i18next'
import * as React from 'react'
import Wave from 'react-wavify'
import { Entity } from 'ts-lenses'
import { Action, IOWidget } from 'widgets-for-react'
import { fromJSX } from '../../../../../utils'
import { CustomPagesState } from '../../types.mod'
import { enableHoverMotion, enableReducedMotion } from '../Fc150Years.utils'


interface HomeSplashState {
  show: 'show' | "expanding" | "wave-up" |  "no-show"
}

export const HomeSplash: IOWidget<CustomPagesState['Fc150YearsMainPage'], Action<CustomPagesState['Fc150YearsMainPage']>> =
  s0 => fromJSX(setState => {
    if (s0.homeState.splashState == 'no-show') {
      window.removeEventListener('mousemove', splashMouseMove);
      return null
    }

    window.addEventListener('mousemove', splashMouseMove);

    let wavePaused: boolean = enableReducedMotion;
    if(s0.homeState.splashState != 'wave-up') {
      wavePaused = true;
    }
    
    return (
      <div className="main main--splash" data-state={s0.homeState.splashState} aria-hidden="true">
        <div className="main__inner">
          <div className="header header--fc">
            <div className="header__inner">
              <div className="header__fauxlink">
                <img className="header__logo--fc" src="/frontend/images/logo-subtitle.svg" alt="" width="283" height="92" />
              </div>
            </div>
          </div>

          <div className="splash theme--default">
            <div className="splash__inner grid--gutter">
              <div className="splash__content">
                <p className="splash__pretitle typo--l">{t("splash.title_1")}</p>
                <p className="sr-text">150 {s0.lang == 'en' ? 'year' : 'jaar'}</p>

                <div className="splash__logo">
                  <svg className="splash__svg" width="545" height="342" viewBox="0 0 545 342">
                    <defs>
                      <mask id="m" maskUnits="userSpaceOnUse" x="0" y="0" width="545" height="342">
                        <circle id="splash-circle" cx="-10" cy="-100" r="200" fill="white" />
                      </mask>
                    </defs>
                    <image width="545" height="342" xlinkHref="/frontend/images/logo--150-white.svg" />
                    <image mask="url(#m)" width="545" height="342" xlinkHref="/frontend/images/logo--150.svg" />
                  </svg>
                </div>

                <p className="splash__posttitle typo--l">{t("splash.title_2")}</p>
              </div>
            </div>

            <div className="splash__footer">
              <button className="splash__button blob-button"
                disabled={s0.state.page.page.kind != 'loaded'}
                onClick={() => {
                splashButtonClick();
                // FIRST ADD EXPANDING CLASS
                  setState(s => Entity(s).setIn('homeState', homeState =>
                    homeState.set('splashState', show => {
                  if (show == 'show') {
                    return 'expanding'
                  }
                  return 'no-show'
                    })).commit())
                // AFTER EXPAND ANIMATION IS DONE CHANGE TO WAVE UP
                setTimeout(() => {
                  setState(s => Entity(s).setIn('homeState', homeState =>
                    homeState.set('splashState', show => {
                    if (show == 'expanding') {
                      return 'wave-up'
                    } return 'no-show'
                    })).commit())
                }, 1200)
                // AFTER WAVE UP WE REMOVE SPLASH
                setTimeout(() => {
                  setState(s => Entity(s).setIn('homeState', homeState =>
                    homeState.set('splashState', show => {
                    if (show == 'wave-up') {
                      return 'no-show'
                    }
                    return 'show'
                    })).commit())
                }, 2400)
              }}>
                <span className="blob-button__label typo--2xs">{t('splash.button')}</span>
                <div className="blob-button__icon" aria-hidden="true" />

                <div className="blob-button__waves" aria-hidden="true">
                  <svg className="blob-button__wave top-left" preserveAspectRatio="none" height="10" viewBox="0 0 64 10" width="64" xmlns="http://www.w3.org/2000/svg"><path d="m32 7h41.7234192c13.7447739 0 13.7217712-7 21.309082-7s10.5496828 7 19.6493838 7h73.391267c5.398704 0 10.675361-3.53967285 16.074065-3.53967285 4.843061 0 9.808168 3.53967285 14.65123 3.53967285h28.201553c17.673112 0 32 14.326888 32 32s-14.326888 32-32 32c-28.170888 0-56.341777 0-84.512665 0-15.806824 0-18.96208 10-31.487335 10s-16.233429-10-32.234436-10c-22.255188 0-44.510376 0-66.765564 0-17.673112 0-32-14.326888-32-32s14.326888-32 32-32z" fillRule="evenodd" transform="translate(-99 -71)"/></svg>
                  <svg className="blob-button__wave top-right" preserveAspectRatio="none" height="10" viewBox="0 0 64 10" width="64" xmlns="http://www.w3.org/2000/svg"><path d="m32 7h41.7234192c13.7447739 0 13.7217712-7 21.309082-7s10.5496828 7 19.6493838 7h73.391267c5.398704 0 10.675361-3.53967285 16.074065-3.53967285 4.843061 0 9.808168 3.53967285 14.65123 3.53967285h28.201553c17.673112 0 32 14.326888 32 32s-14.326888 32-32 32c-28.170888 0-56.341777 0-84.512665 0-15.806824 0-18.96208 10-31.487335 10s-16.233429-10-32.234436-10c-22.255188 0-44.510376 0-66.765564 0-17.673112 0-32-14.326888-32-32s14.326888-32 32-32z" fillRule="evenodd" transform="translate(-99 -71)"/></svg>
                  <svg className="blob-button__wave bottom" preserveAspectRatio="none" height="10" viewBox="0 0 64 10" width="64" xmlns="http://www.w3.org/2000/svg"><path d="m32 7h41.7234192c13.7447739 0 13.7217712-7 21.309082-7s10.5496828 7 19.6493838 7h73.391267c5.398704 0 10.675361-3.53967285 16.074065-3.53967285 4.843061 0 9.808168 3.53967285 14.65123 3.53967285h28.201553c17.673112 0 32 14.326888 32 32s-14.326888 32-32 32c-28.170888 0-56.341777 0-84.512665 0-15.806824 0-18.96208 10-31.487335 10s-16.233429-10-32.234436-10c-22.255188 0-44.510376 0-66.765564 0-17.673112 0-32-14.326888-32-32s14.326888-32 32-32z" fillRule="evenodd" transform="translate(-99 -71)"/></svg>
                  <div className="blob-button__bubble bottom-left"/>
                  <div className="blob-button__bubble bottom-right"/>
                  <div className="blob-button__bubble top-left"/>
                  <div className="blob-button__bubble top-right"/>
                </div>
              </button>

              <div className="splash__waves">
                <Wave fill="rgb(255, 255, 255, 0)" stroke='rgb(255, 255, 255, .1)'
                  paused={enableReducedMotion}
                  options={{
                    height: 30,
                    amplitude: 20,
                    speed: 0.1,
                    points: 8
                  }}
                  className="splash__wave"
                />
                <Wave fill="rgb(255, 255, 255, 0)" stroke='rgb(255, 255, 255, .2)'
                  paused={enableReducedMotion}
                  options={{
                    height: 30,
                    amplitude: 20,
                    speed: 0.1,
                    points: 5
                  }}
                  className="splash__wave"
                />
                <Wave fill="rgb(255, 255, 255, 0)" stroke='rgb(255, 255, 255, 0.25)'
                  paused={enableReducedMotion}
                  options={{
                    height: 30,
                    amplitude: 20,
                    speed: 0.1,
                    points: 6
                  }}
                  className="splash__wave"
                />
              </div>
            </div>

            <div className="splash__portrait">
              <div className="portrait portrait--small portrait--splash">
                <div className="portrait__inner">
                  <div className="portrait__shape" />
                </div>
              </div>
            </div>
          </div>

          <div className="splash__anim pageanim">
            <div className="pageanim__waves">
              <Wave fill='rgb(255, 255, 255, .5)'
                paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                options={{
                  height: 60,
                  amplitude: 60,
                  speed: 0.1,
                  points: 8
                }}
                className="pageanim__wave"
              />
              <Wave fill='rgb(255, 255, 255, .65)'
                paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                options={{
                  height: 60,
                  amplitude: 60,
                  speed: 0.1,
                  points: 5
                }}
                className="pageanim__wave"
              />
              <Wave fill='rgb(255, 255, 255, 1)'
                paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                options={{
                  height: 60,
                  amplitude: 60,
                  speed: 0.1,
                  points: 6
                }}
                className="pageanim__wave"
              />
            </div>
          </div>
        </div>
      </div>
    )
  })

function splashMouseMove(e:MouseEvent) {
  if ((enableHoverMotion == false || window.innerWidth < 768)) {
    window.removeEventListener('mousemove', splashMouseMove);
    return;
  }

  // PORTRAIT
  const el:HTMLElement = document.querySelector('.splash__portrait');
  const elSplash:HTMLElement = document.querySelector('.main--splash');

  if(el == null) { return; }
  if(elSplash.getAttribute('data-state') == 'expanding') {
    return;
  }

  el.style.top = `${e.clientY}px`;
  el.style.left = `${e.clientX}px`;
  el.classList.add('init');

  // LOGO
  const elImg:HTMLElement = document.querySelector('.splash__svg');
  const elMask:HTMLElement = document.getElementById('splash-circle');

  if((elImg == null || elMask == null)) { return; }

  elMask.setAttribute('cx', `${e.clientX - elImg.getBoundingClientRect().left}`);
  elMask.setAttribute('cy', `${e.clientY - elImg.getBoundingClientRect().top}`);

  const elInner:HTMLElement = document.querySelector('.splash__portrait .portrait__inner');
  if(elInner == null) { return; }
  elMask.setAttribute('r', `${elInner.getBoundingClientRect().height / 2}`);

  const elButton:HTMLElement = document.querySelector('.splash__button');
  if(elButton == null) { return; }
  const elButtonRect:DOMRect = elButton.getBoundingClientRect();

  // Reduce size of portrait when inside the button
  if(
    (elButtonRect.top - e.clientY) < 0 &&
    (elButtonRect.bottom - e.clientY) > 0 &&
    (elButtonRect.left - e.clientX) < 0 &&
    (elButtonRect.right - e.clientX) > 0
  ) {
    elInner.style.transform = `scale(${0.2})`;
  } else {
    elInner.removeAttribute('style');
  }
}

function splashButtonClick() {
  window.removeEventListener('mousemove', splashMouseMove);

  if ((enableHoverMotion == false || window.innerWidth < 768)) {
    const el:HTMLElement = document.querySelector('.splash__portrait');
    const elButton:HTMLElement = document.querySelector('.splash__button');

    if((el == null || elButton == null)) { return; }

    el.style.top = `${elButton.getBoundingClientRect().top}px`;
    el.style.left = `$${elButton.getBoundingClientRect().left}px`;
  }
}
